export const ENDPOINT_MAIN_DUTIES_FIND_ALL = '/api/main-duties/list';
export const ENDPOINT_MAIN_DUTIES_CREATE_ONE = '/api/main-duties/create';
export const ENDPOINT_MAIN_DUTIES_UPDATE_ONE = '/api/main-duties/update';
export const ENDPOINT_MAIN_DUTIES_DELETE_ONE = '/api/main-duties/delete';
export const ENDPOINT_MAIN_DUTIES_GET_ONE = '/api/main-duties/get-one';
